import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Aluno } from 'src/app/core/aluno';
import { GrausInstrucao } from 'src/app/core/graus-instrucao';
import { PessoaFisica } from 'src/app/core/pessoa-fisica';
import { GrausInstrucaoService } from './../../../../services/graus-instrucao/graus-instrucao.service';

@Component({
  selector: 'escolaridade',
  templateUrl: './escolaridade.component.html',
  styleUrls: ['./escolaridade.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class EscolaridadeComponent implements OnInit {

  @Input() aluno: Aluno;
  @Input() pessoaFisica: PessoaFisica;


  formaIngresso: any[] = [
    { tipo: 'CRAS' },
    { tipo: 'DEMANDA ESPONTÂNEA' },
    { tipo: 'SOLICITAÇÃO JUDICIAL' },
    { tipo: 'OUTRO' },
  ];

  tipoEscola: any[] = [
    { id: 'P', tipo: 'PÚBLICO' },
    { id: 'R', tipo: 'PRIVADO' },
  ];

  nivelEscolaridade: any[] = [
    { id: 'C', tipo: 'COMPLETO' },
    { id: 'I', tipo: 'CURSANDO' },
  ]

  constructor(private grausInstrucaoService: GrausInstrucaoService) {
  }

  ngOnInit() {
    this.pessoaFisica.grausInstrucao = new GrausInstrucao();
  }

  onGrauInstrucaoChange(grauInstrucao: any) {
    this.pessoaFisica.grausInstrucao = grauInstrucao;
  }

}
